import Quill from 'quill';
import { RoutePaths } from 'routes/RouteConfig';

const BlockEmbed = Quill.import('blots/embed');

class MentionBlot extends BlockEmbed {
    static create(data: any) {
        if (data.denotationChar) {
            const node = super.create();
            const denotationChar = document.createElement('span');
            denotationChar.className = 'ql-mention-denotation-char';
            denotationChar.innerHTML = data.denotationChar;
            node.appendChild(denotationChar);

            const a = document.createElement("a");
            a.className = 'ql-mention-link';
            a.setAttribute("href", RoutePaths.UserProfileViewer.replace(":id?", data.id));
            a.setAttribute("target", "_blank");
            a.innerHTML = data.value;
            node.appendChild(a);

            //node.innerHTML += data.displayName;
            node.dataset.id = data.id;
            node.dataset.value = data.value;
            node.dataset.denotationChar = data.denotationChar;

            return node;
        }
        return data;
    }

    static value(domNode: any) {
        return domNode;
    }

    static blotName = 'mention';
    static tagName = 'span';
    static className = 'mention';

}


Quill.register(MentionBlot);
